<tt-page *ngIf="page">
    <tt-card class="col-xs-12 col-md-3 sp-0">
        <tt-input ttLabel="shift_id" [ttModel]="page.shift_id" ttReadonly></tt-input>
        <tt-input ttLabel="dayname" [ttModel]="page.day_name" ttReadonly></tt-input>
        <tt-time ttLabel="from_time" [ttModel]="page.from_time" (ttModelChange)="onTimeChanged($event, 'from_time')" [ttMinutePrecision]="1"></tt-time>
        <tt-time ttLabel="to_time" [ttModel]="page.to_time" (ttModelChange)="onTimeChanged($event, 'to_time')" [ttMinutePrecision]="1"></tt-time>
        <tt-input-number ttLabel="breakhour" [ttModel]="page.breakhour" [ttDecimals]="2" ttReadonly></tt-input-number>
        <tt-button-save *ngIf="+page.breakhour > 0" ttText="save" [ttLoading]="saving || validating" (ttClick)="saveChanges()"></tt-button-save>
        <tt-button *ngIf="+page.shiftbreak_keyno > 0" ttText="delete" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteValues()"></tt-button>
    </tt-card>
</tt-page>
